import { Button, Tooltip } from '@material-ui/core'

import React, { useMemo } from 'react'
import { Grid } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import {
  ItemContainer,
  ShopLabel,
  StatusIcon,
  StyledDivider,
  Title,
  TitleContainer,
} from '../styled'
import { CompanyShopsAndEmployeesMigrationResponse } from 'types/migration'
import { Typography } from '@material-ui/core'
import { CountNumber, EmployeeCount } from '../styled'
import { ReactSelectOption } from 'types'
import SyncIcon from '@material-ui/icons/Sync'
import ErrorIcon from '@material-ui/icons/Error'
import { trimString } from '../../../../../utils/stringV2'

interface CompanyCollectionDetailsContentProps {
  selectedCompany?: ReactSelectOption
  companyMigrationDetails?: CompanyShopsAndEmployeesMigrationResponse
  selectedShops?: ReactSelectOption[]
  onSyncCompanyData?: () => void
}

export const CompanyCollectionDetailsContent = ({
  selectedCompany,
  companyMigrationDetails,
  selectedShops,
  onSyncCompanyData,
}: CompanyCollectionDetailsContentProps) => {
  const companyIsSynced = Boolean(companyMigrationDetails?.data?.platformCompanyId)
  const syncedShops = companyMigrationDetails?.data?.syncedShopIds
  const syncedEmployees = companyMigrationDetails?.data?.syncedEmployeeIds
  const maxNameLength = 25

  const syncMissingShops = () => {
    onSyncCompanyData?.()
  }

  const sortedShops = useMemo(() => {
    if (!selectedShops) return []
    return [...selectedShops].sort((a, b) => {
      const aIsSynced = syncedShops?.includes(a.value)
      const bIsSynced = syncedShops?.includes(b.value)
      if (aIsSynced === bIsSynced) return 0
      return aIsSynced ? 1 : -1
    })
  }, [selectedShops, syncedShops])

  const missingShops = useMemo(() => {
    if (!selectedShops || !syncedShops) return []
    return selectedShops.filter((shop) => !syncedShops.includes(shop.value))
  }, [selectedShops, syncedShops])

  const isMissingShops = missingShops.length > 0 || companyMigrationDetails === undefined
  const noShopsSelected = selectedShops === undefined || selectedShops.length === 0
  return (
    <Grid style={{ maxHeight: 400, overflow: 'auto' }}>
      <div>
        {!!isMissingShops && (
          <TitleContainer>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                style={{ display: 'flex', gap: '10px' }}
                onClick={syncMissingShops}
                className="button-blue-and-white-no-margin"
                disabled={noShopsSelected}
              >
                <span>Sync missing company data</span>
                <SyncIcon style={{ color: 'white' }} />
              </Button>
              {!!noShopsSelected && (
                <span style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 4 }}>
                  <ErrorIcon style={{ fontSize: 18, color: 'rgb(255 168 16)' }} /> You need to
                  select shops first
                </span>
              )}
            </div>
          </TitleContainer>
        )}
        <StyledDivider />
        <Title>Company</Title>
        {selectedCompany && (
          <ItemContainer>
            <ShopLabel>{selectedCompany.label}</ShopLabel>
            <StatusIcon>
              {companyIsSynced ? (
                <CheckCircleIcon style={{ color: 'green' }} />
              ) : (
                <CancelIcon style={{ color: 'red' }} />
              )}
            </StatusIcon>
          </ItemContainer>
        )}
      </div>

      <StyledDivider />
      <div>
        <TitleContainer>
          <Title>Shops</Title>
        </TitleContainer>

        {sortedShops.length > 0 ? (
          sortedShops.map((shop) => {
            const shouldTruncateName = shop.label.length > maxNameLength
            return (
              <ItemContainer key={shop.value}>
                {shouldTruncateName ? (
                  <Tooltip
                    title={<Typography style={{ color: 'white' }}>{shop.label}</Typography>}
                    placement="top"
                  >
                    <ShopLabel>{trimString(shop.label, maxNameLength)}</ShopLabel>
                  </Tooltip>
                ) : (
                  <ShopLabel>{shop.label}</ShopLabel>
                )}
                <StatusIcon>
                  {syncedShops?.includes(shop.value) ? (
                    <CheckCircleIcon style={{ color: 'green' }} />
                  ) : (
                    <CancelIcon style={{ color: 'red' }} />
                  )}
                </StatusIcon>
              </ItemContainer>
            )
          })
        ) : (
          <Typography style={{ fontStyle: 'italic' }}>No shops selected</Typography>
        )}
      </div>
      <StyledDivider />
      <div>
        <Title>Employees</Title>
        <EmployeeCount>
          <CountNumber>{syncedEmployees === undefined ? '0' : syncedEmployees?.length}</CountNumber>
          <Typography>employees synced</Typography>
        </EmployeeCount>
      </div>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/CompanyCollectionDetailsModal/CompanyCollectionDetailsContent.tsx